// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/airport-ground-rules.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/airport-ground-rules/airport-ground-rules.js';

mount([g0]);
